import React from "react";

const OverviewCard = ({ href, label, onNavigate }) => (
  <a
    href={href}
    className="overview-card"
    onClick={(event) => onNavigate(event, href)}
  >
    <span className="overview-card-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="3">
        <path d="M5 12.5l4.2 4.2L19 7.5" />
      </svg>
    </span>
    <span className="overview-card-label">{label}</span>
  </a>
);

export default OverviewCard;
